<template>
  <div>
      
      <el-row
        type="flex"
        justify="space-start"
        :gutter="30"
      >

      <el-col :span="18">
          <el-card class="box-card">
            <div class="card-header">
                <h4 class="card-title">Transactions</h4>
              
                <p><strong>Showing: </strong><span class="text-info">{{filters[0].value | niceStatus}} </span>orders from <span class="text-info">{{filters[1].value | niceRegion}}</span> on <span class="text-info">{{filters[2].value[0] | moment("MMMM Do YYYY")}}</span></p>

            </div>

            <div class="card-content">

              <el-collapse v-model="currentDate" @change="loadDates">
                <el-collapse-item :title="niceDate(date)" :name="date" v-for="(date,index) in dates" :key="index">
                 <el-tag type="success" class="label label-primary pull-right" style="margin:10px 0">Transactions: {{total[date]}} &nbsp;&nbsp;|&nbsp;&nbsp; Total: £{{Number(aggregate[date]).toLocaleString(undefined, { maximumFractionDigits: 2 })}}</el-tag> 
     <!--              <el-tag type="success" class="label label-primary pull-right" style="margin:10px 0" v-if="aggregate[date] && aggregate[date].sum.totalPaid >= 20000">Total: £{{aggregate[date].sum.totalPaid.toLocaleString(undefined, { maximumFractionDigits: 2 })}}</el-tag>
                  <el-tag type="success" class="label label-success pull-right" style="margin:10px 0" v-if="aggregate[date] && aggregate[date].sum.totalPaid >= 10000 && aggregate[date].sum.totalPaid < 20000">Total: £{{aggregate[date].sum.totalPaid.toLocaleString(undefined, { maximumFractionDigits: 2 })}}</el-tag>
                  <el-tag type="warning" class="label label-warning pull-right" style="margin:10px 0" v-if="aggregate[date] && aggregate[date].sum.totalPaid < 10000 && aggregate[date].sum.totalPaid > 5000">Total: £{{aggregate[date].sum.totalPaid.toLocaleString(undefined, { maximumFractionDigits: 2 })}}</el-tag>
                  <el-tag type="danger"  class="label label-danger  pull-right" style="margin:10px 0" v-if="aggregate[date] && aggregate[date].sum.totalPaid > 0 && aggregate[date].sum.totalPaid <= 5000">Total: £{{aggregate[date].sum.totalPaid.toLocaleString(undefined, { maximumFractionDigits: 2 })}}</el-tag>
                   -->
                  <el-table
                    class="table-shopping" 
                    style="width: 100%" 
                    height="350"
                    :data="orders[date]" 
                    :tool-bar="false" 
                    :loading="loadingOrders"
                    >

                      <el-table-column
                        min-width="50"
                        label="ID"
                        prop="id"
                      >
                        <template slot-scope="props">
                          <span>{{props.row.id}} </span>
                        </template>
                      </el-table-column>

                      <el-table-column
                        label="Time"
                        min-width="70"
                        prop="dateCreated"
                        sortable="custom"
                      >
                        <template slot-scope="props">
                          {{props.row.dateCreated | moment('hh:mm a') }}
                        </template>
                      </el-table-column>

                      <el-table-column
                        min-width="100"
                        class="td-price"
                        label="Customer"
                      >
                        <template slot-scope="props">
                          <router-link
                            v-if="props.row.customer"
                            :to="'/customer/edit/'+props.row.customer.id"
                          >{{props.row.customer.firstname}} {{props.row.customer.lastname}}</router-link>
                        </template>
                      </el-table-column>

                  
                      <el-table-column
                        min-width="150"
                        class="td-price"
                        label="Order"
                      >
                        <template slot-scope="props">
                          <router-link :to="'/order/edit/'+props.row.orderId">{{ props.row.orderId }}</router-link>
                         
                        </template>
                      </el-table-column>

                      <el-table-column
                        min-width="150"
                        class="td-price"
                        label="Currency"
                      >
                        <template slot-scope="props">
                          {{ props.row.currency.toUpperCase() }}
                         
                        </template>
                      </el-table-column>


                      <el-table-column
                        min-width="50"
                        class="td-price"
                        prop="totalPaid"
                        label="Total"
                      >
                        <template slot-scope="props">
                         
                          <span
                            v-if="props.row.currency.toUpperCase()=='GBP'"
                          >£{{props.row.amountPaid}}</span>
                          <span
                            v-if="props.row.currency.toUpperCase()=='USD'"
                          >${{props.row.amountPaid }} <br /> £{{Math.round(props.row.totalConverted)}}</span>
                          <span
                            v-if="props.row.currency.toUpperCase()=='EUR'"
                            >€{{props.row.amountPaid }} <br /> £{{Math.round(props.row.totalConverted)}}</span>
                                <span
                            v-if="props.row.currency.toUpperCase()=='AUD'"
                            >A${{props.row.amountPaid }} <br /> £{{Math.round(props.row.totalConverted)}}</span>
                          <span
                            v-if="props.row.currency.toUpperCase()=='CAD'"
                          >C${{props.row.amountPaid }} <br /> £{{Math.round(props.row.totalConverted)}}</span>
                          <span
                            v-if="props.row.currency.toUpperCase()=='ZAR'"
                          >R{{props.row.amountPaid }} <br /> £{{Math.round(props.row.totalConverted)}}</span>
                        </template>
                      </el-table-column>

                      

                      <el-table-column
                        label="Edit"
                        min-width="50"
                      >
                        <template slot-scope="props">
                          <router-link :to="'/order/edit/'+props.row.orderId">Edit</router-link>
                        </template>
                      </el-table-column>

                    </el-table>

                </el-collapse-item>

              </el-collapse>
              
              <br />
            </div>
          </el-card>

        </el-col>

        <el-col :span="6">
          <el-card class="box-card" v-if="this.aggregate[currentDate]">

            <div class="card-header">
              <h4 class="card-title">Stats</h4>
              <p class="category">Stats for <span class="text-info">{{filters[2].value[0] | moment("MMMM Do YYYY")}}</span> <br><small>(note all currencies are grouped into GBP so these values are approximate only.)</small></p>
              <br>
              <h5 style="margin-bottom:-23px;">Total:</h5>
             <h3>{{Number(aggregate[currentDate]).toLocaleString(undefined, { maximumFractionDigits: 2 })}}</h3> 
<!--               <h3 v-if="this.aggregate[currentDate].sum.totalPaid != null">£{{this.aggregate[currentDate].sum.totalPaid.toLocaleString(undefined, { maximumFractionDigits: 2 })}}</h3>
              <h3 v-if="this.aggregate[currentDate].sum.totalPaid === null">N/A</h3>
              <h5 style="margin-bottom:-23px;">Orders:</h5>
              <h3 v-if="this.aggregate[currentDate].count != null">{{this.aggregate[currentDate].count.toLocaleString(undefined, { maximumFractionDigits: 0 })}}</h3>
              <h5 style="margin-bottom:-23px;">Average order value:</h5>
              <h3 v-if="this.aggregate[currentDate].sum.totalPaid != null">£{{this.aggregate[currentDate].avg.totalPaid.toLocaleString(undefined, { maximumFractionDigits: 2 })}}</h3>
              <h3 v-if="this.aggregate[currentDate].sum.totalPaid === null">N/A</h3> -->
            </div>

          </el-card>
          <el-card class="box-card">
            
            <div class="card-header">
              <h5 class="card-title">Taster Signups<el-tag type="info">{{tasterSignups}} </el-tag><small class="sm"> (last 7 days)</small></h5>
            </div>
       
          </el-card >
<el-card class="box-card">
            
            <div class="card-header">
              <h5 class="card-title">Brochure Signups <el-tag type="info" > {{brochureSignups}} </el-tag>  <small class="sm"> (last 7 days)</small></h5>
            </div>
         
              
          </el-card >
        </el-col>

      </el-row>
    <!-- dev
     -->

  </div>

</template>
<script>
import StatsCard from "src/components/UIComponents/Cards/StatsCard.vue";
import api from "../../../Mailchimp/api";
//import orders from "../../../Orders/List"
import _ from "lodash";
import gql from "graphql-tag";
import moment from "moment";
export default {
  components: {
    StatsCard
  },
  data() {
    return {
      tasterSignups:0,
       brochureSignups:0,
      loadingOrders: false,
      $Chartist: null,
      labelToCur:{
        TEFLORG:'GBP',
        TEFLUS:'USD',
        IRELAND:'EUR',
        AUSTRALIA:'AUD',
        CANADA:'CAD',
        SOUTHAFRICA:'ZAR'




      },
      curToLabel:{
        GBP:'TEFLORG',
        USD:'TEFLUS',
        EUR:'IRELAND',
        AUD:'AUSTRALIA',
        CAD:'CANADA',
        ZAR:'SOUTHAFRICA'




      },
      currentDate: moment().format('YYYY-MM-DD'),
      filters: [
        {
          value: "2",
          prop: "status",
        }, 
        {
          value: "ALL",
          prop: "currency"
        },
        {
          value: [
            moment().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss'),
            moment().format('YYYY-MM-DD HH:mm:ss')
          ],
          prop: "dateCreated"
        }
      ],
      pickerOptions1: {
        shortcuts: [
          {
            text: "Last 24 hours",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last week",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Two Weeks",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "3 months",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "6 months",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "1 year",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      orders:{},
      numberOfDays: 14,
      dates: [],
      aggregate: {},
      total: {},
      rates:{}
    };
  },
 
  methods: {   

    outputDate(number){
      this.currentDate = moment().subtract(number, "days").format("YYYY-MM-DD");  
      return this.currentDate
    },
    niceDate(date){
      return moment(date).format("ddd, MMMM Do YYYY");
    },
    setDates(number){
      for (var i = 0; i < number; i++) {
          this.dates.push(moment(this.currentDate).subtract(i, "days").format("YYYY-MM-DD"));
      }
      var startDate = []
      startDate.push(this.currentDate);
      this.loadDates(startDate);
    },
    loadDates(date) {
        var newDate = date.slice(-1)[0] 
        this.filters[2].value[0] = moment(newDate+'T00:00:01').format('YYYY-MM-DD HH:mm:ss')
        this.filters[2].value[1] = moment(newDate+'T23:59:59').format('YYYY-MM-DD HH:mm:ss')
        this.currentDate = moment(newDate).format("YYYY-MM-DD");
        if (this.orders[this.currentDate] === undefined){
          this.loadData();
        }
    },
    async loadData(queryInfo) {
      this.loadingOrders = true//  
      this.$apollo
        .query({
          // desc_nulls_last filters out any null data
          query: gql`
 
  {rates(where: {date: {_eq: "${moment(this.currentDate).subtract(1,'days').format('YYYY-MM-DD')}"}}) {
    id
    date
    base
    rate
  }
  }`
}).then(r =>{
  //.group(({ type }) => type);
  this.rates= r.data.rates


      
      if ( queryInfo != undefined ) {
        var type = queryInfo.type;
        var page = queryInfo.page;
        var pageSize = queryInfo.pageSize;
        var orderDir = 'desc_nulls_last';
        var orderProp = 'dateCreated';
        (queryInfo.type === 'page' || queryInfo.type === 'size' || queryInfo.type === 'sort') &&
        this.$message(`page: ${queryInfo.page}, pageSize: ${queryInfo.pageSize}, prop: ${queryInfo.sort.prop}, order: ${queryInfo.sort.order}`)
        
        if (queryInfo.sort.order === 'ascending') {
          orderDir = 'asc_nulls_last';
        } else if (queryInfo.sort.order === 'descending') {
          orderDir = 'desc_nulls_last';
        } else {}
        if (queryInfo.sort.prop != undefined) {
          orderProp = queryInfo.sort.prop;
        }
      } else {
        var type = 'init';
        var page = 1;
        var pageSize = 200;
        var orderDir = 'desc_nulls_last';
        var orderProp = 'dateCreated';
      }
      console.log('queryinfo: ', queryInfo)
      console.log('loading data...')
      //Defaults
      var startDate = this.filters[2].value[0];
      var endDate = this.filters[2].value[1];
      var equal = this.filters[1].value === "ALL" ? "_neq" : "_eq"
      var equalStatus = this.filters[0].value === "ALL" ? "_neq" : "_eq"
      this.$apollo
        .query({
          // desc_nulls_last filters out any null data
          query: gql`
            {
              Transaction(
                limit: ${pageSize}, 
                offset: ${(page - 1) * pageSize}, 
                order_by: {${orderProp}: ${orderDir}}, 
                where: { 
                  _and: [
                    { dateCreated: {_gte: "${startDate}"}},
                    { dateCreated: {_lte: "${endDate}"}}
                  ]
                }
              ) {
                id
                dateCreated
                customer {
                  firstname
                  lastname
                  id
                }
                amountPaid
                amountAttempted
                currency
                orderId
                customerId
              }
              Transaction_aggregate(
                where: { 
                  _and: [
                    { dateCreated: {_gte: "${startDate}"}},
                    { dateCreated: {_lte: "${endDate}"}}
                  ]
                }
              ) {
                aggregate {
                  sum {
                    amountPaid
                    amountAttempted
                  }
                  count
                  avg {
                    amountPaid
                    amountAttempted
                  }
                }
              }

            }
          `,
          // can get error if needed
          error(error) {
            this.error = JSON.stringify(error);
          }
        })
        .then(response => {
          console.log('REPONSE',response)
         
          //this.orders = response.data.Order;
          // i = 0
          console.log(response)
          var dateCreated = moment(startDate).format('YYYY-MM-DD');
          if (this.orders[dateCreated] === undefined) {
            this.orders[dateCreated] = []
            this.orders[dateCreated] = response.data.Transaction
          }
          if (this.aggregate[dateCreated] === undefined) {
            this.aggregate[dateCreated] = []
            this.aggregate[dateCreated] = response.data.Transaction.map(item => item).reduce((prev, next) => {
              console.log('next',next,this.rates)
              if(next.currency.toUpperCase() !== 'GBP'){
                  next.totalConverted = next.amountPaid * this.rates.find(obj => obj.base === next.currency.toUpperCase()).rate
              }
              else{
                next.totalConverted = next.amountPaid
              }
              return prev + next.totalConverted
            },0);
            
          }
          
        
          if (this.total[dateCreated] === undefined) {
            this.total[dateCreated] = []
            this.total[dateCreated] = response.data.Transaction_aggregate.aggregate.count;
          }
       
          /*for (let order of response.data.Order) {
              if (dateCreated != moment(order.dateCreated).format("YYYY-MM-DD")) {
                dateCreated = moment(order.dateCreated).format("YYYY-MM-DD")
                i = i+1
                this.orders[dateCreated] = []
              }
              this.orders[dateCreated].push(order);
          }*/
          //this.aggregate = response.data.Order_aggregate.aggregate;
          //this.total = response.data.Order_aggregate.aggregate.count;
          this.loadingOrders = false;
          console.log('Dates: ',this.dates);
          console.log('Orders: ',this.orders);
          console.log('Aggregate: ',this.aggregate);
          console.log('Total: ',this.total);
        });
      })
    },
    async getTasterSignups(){
      api.getTasterSignups().then((result) =>{
        console.dir(result)
        this.tasterSignups=result.data.total_items
      })
    },
    async getBrochureSignups(){
      api.getBrochureSignups().then((result) =>{
        console.dir(result)
        this.brochureSignups=result.data.total_items
      })
    }
   
  },
  async mounted() {
    this.setDates(this.numberOfDays);
    this.getTasterSignups()
    this.getBrochureSignups()
  },
  computed: {
    
  }
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Dashboard/Transactions.vue